export const PARTNERS = [
  {
    name: "Golidawai.com",
    imageUrl: "golidawai.png",
  },
  {
    name: "Samsung",
    imageUrl: "samsung.png",
  },
  {
    name: "My Computers",
    imageUrl: "mycomputers.png",
  },
  {
    name: "Ingram",
    imageUrl: "ingram.png",
  },
  {
    name: "crucial",
    imageUrl: "crucial.png",
  },
  {
    name: "acer",
    imageUrl: "acer.png",
  },
  {
    name: "acronis",
    imageUrl: "acronis.png",
  },
  {
    name: "amd",
    imageUrl: "amd.png",
  },
  {
    name: "CyberPower",
    imageUrl: "CyberPower.png",
  },
  {
    name: "apple",
    imageUrl: "Apple.png",
  },
  {
    name: "aruba",
    imageUrl: "aruba.png",
  },
  {
    name: "asus",
    imageUrl: "asus.png",
  },
  {
    name: "baracuda",
    imageUrl: "baracuda.png",
  },
  {
    name: "cisco",
    imageUrl: "cisco.png",
  },
  {
    name: "Dlink",
    imageUrl: "Dlink.png",
  },
  {
    name: "epson",
    imageUrl: "epson.png",
  },
  {
    name: "f5",
    imageUrl: "f5.png",
  },
  {
    name: "fortinet",
    imageUrl: "fortinet.png",
  },
  {
    name: "gigabyte",
    imageUrl: "gigabyte.png",
  },
  {
    name: "hikvision",
    imageUrl: "hikvision.png",
  },
  {
    name: "huawei",
    imageUrl: "huawei.png",
  },
  {
    name: "ibm",
    imageUrl: "ibm.png",
  },
  {
    name: "kingston",
    imageUrl: "kingston.png",
  },
  {
    name: "lenovo",
    imageUrl: "lenovo.png",
  },
  {
    name: "micron",
    imageUrl: "micron.png",
  },
  {
    name: "microsoft",
    imageUrl: "microsoft.png",
  },
  {
    name: "Mikrotik",
    imageUrl: "Mikrotik.png",
  },
  {
    name: "molex",
    imageUrl: "molex.png",
  },
  {
    name: "nokia",
    imageUrl: "nokia.png",
  },
  {
    name: "nutanix",
    imageUrl: "nutanix.png",
  },
  {
    name: "nvidia",
    imageUrl: "nvidia.png",
  },
  {
    name: "dell",
    imageUrl: "dell.png",
  },
  {
    name: "hp",
    imageUrl: "hp.png",
  },
  {
    name: "qnap",
    imageUrl: "qnap.png",
  },
  {
    name: "sandisk",
    imageUrl: "sandisk.png",
  },
  {
    name: "sophos",
    imageUrl: "sophos.png",
  },
  {
    name: "synlogy",
    imageUrl: "synlogy.png",
  },
  {
    name: "toshiba",
    imageUrl: "toshiba.png",
  },
  {
    name: "tplink",
    imageUrl: "tplink.png",
  },
  {
    name: "ubiquiti",
    imageUrl: "ubiquiti.png",
  },
  {
    name: "veam",
    imageUrl: "veam.png",
  },
  {
    name: "vertiv",
    imageUrl: "vertiv.png",
  },
  {
    name: "WD",
    imageUrl: "WD.png",
  },
];

export const ALL_DETAIL_ROUTES_INFO = [...PARTNERS];
